

const Contact = () => {
    return (<>
       <div> Contact me.</div>
    </>)
}

export default Contact;